import React from 'react';
import ReactLoading from 'react-loading';

import styles from './_styles/Loading.module.scss';

const Loading = () => {

  return (
    <div className={styles.wrap}>
      <ReactLoading color="#223f9a" type="cylon" />
    </div>
  )
};

export default Loading;